export enum HBGModule {
  program = "program",
  community = "community",
  form = "dynamic_form",
}
